import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import CommanCertificate from "./component/CommanCertificate";
import Home from "./component/Home";
import NotFound from "./component/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/view-certificate/:lot" element={<CommanCertificate />} /> */}
        <Route path="/view-certificate/:lot/:suffix?" element={<CommanCertificate />} />
        <Route path="/site/view-certificate" element={<CommanCertificate />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
